import { normalizeBranchValue } from "../config/appBranches";
import {
  getFYSlotForCalendarDate,
  readStoredFinancialYearStartYear,
} from "./financialYear";

export function monthlySaleReportQuery(fyStartYear, fySlot, branchFilter) {
  const q = new URLSearchParams({
    fy: String(fyStartYear),
    slot: String(fySlot),
    branch: branchFilter,
  });
  return q.toString();
}

export function readMonthlySaleReportParams(searchParams, now = new Date()) {
  const fyRaw = searchParams.get("fy");
  const slotRaw = searchParams.get("slot");
  const branch = normalizeBranchValue(searchParams.get("branch") || "Main");
  const fyStartYear =
    fyRaw != null && fyRaw !== "" && !Number.isNaN(Number(fyRaw))
      ? Number(fyRaw)
      : readStoredFinancialYearStartYear();
  const fySlot =
    slotRaw != null && slotRaw !== "" && !Number.isNaN(Number(slotRaw))
      ? Number(slotRaw)
      : getFYSlotForCalendarDate(now);
  return { fyStartYear, fySlot, branchFilter: branch };
}
